module.exports = __webpack_public_path__ + "static/e6926585cbe9e667f724d9083b6a31f3dbd6186b8c6d2b7806caf6f87b254668-770ca3b44230b0deb4bf9cec421198b6.jpeg";